// test1852
(1852 && 0);
